module.exports = __webpack_public_path__ + "img/p2-83.d962b891.png";